import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form-empty"
}
const _hoisted_3 = { class: "action" }

import { onMounted, ref, watch } from "vue";
import { debounce } from "lodash-es";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { analysisPatch } from "@/common/api/rest/analysis/analysis";
import { evaluationEmployeeCreate } from "@/common/api/rest/evaluation/employee";
import {
  employeeCreate,
  employeeShow,
  employeePatch,
} from "@/common/api/rest/employee";

import type { AnalysisType } from "@/common/types/analysis";
import type { CompanyType } from "@/common/types/company";
import type {
  EmployeePayloadType,
  EmployeeListType,
} from "@/common/types/employee";

import { employeeForm, searchEmployee } from "@/components";
import {
  svgIcon,
  baseModal,
  baseConfirm,
  baseTooltip,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'employee',
  props: {
    data: {},
    company: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const employeeData = ref<EmployeePayloadType | null>(null);
const selected = ref<EmployeeListType | null>(null);
const inputSearch = ref("");

const showModalAdd = ref(false);
const showModalNew = ref(false);
const showDelConfirm = ref(false);

function fetchData() {
  if (!props.data?.employee_id) return;

  employeeShow(props.data.account_id, props.data.employee_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        employeeData.value = {
          ...data,
          name: data.name,
        };
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function updateEmployee(payload: EmployeePayloadType) {
  if (!props.data?.employee_id) return;

  employeePatch(props.data.account_id, props.data.employee_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchData(payload: Partial<AnalysisType>) {
  if (!props.data) return;

  analysisPatch(props.data.account_id, props.data.analysis_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function add() {
  showModalAdd.value = true;
}

function addSelect(data: any[]) {
  selected.value = data[0];
}

function addCancel() {
  selected.value = null;
  showModalAdd.value = false;
}

function addConfirm() {
  if (!props.data) return;

  patchData({ employee_id: selected.value?.employee_id });

  inputSearch.value = "";
  addCancel();
}

function del() {
  showDelConfirm.value = true;
}

function delCancel() {
  showDelConfirm.value = false;
}

function delConfirm() {
  patchData({ employee_id: null });
  delCancel();
}

function newRegister(name: string) {
  showModalNew.value = true;
  showModalAdd.value = false;
  selected.value = null;
  employeeData.value = { name } as never;
}

function newRegisterCancel() {
  showModalNew.value = false;
  selected.value = null;
  employeeData.value = null;
}

function evaluationAddEmployee(employee_id: string) {
  if (!props.data) return;

  evaluationEmployeeCreate(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    employee_id,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        patchData({ employee_id });
        newRegisterCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function newRegisterConfirm() {
  if (!props.company?.company_id) {
    toast({ message: "Primeiro adicione uma empresa", type: "error" });
    return;
  }

  showModalNew.value = false;

  employeeCreate(
    props.data.account_id,
    props.company.company_id,
    employeeData.value as EmployeePayloadType,
  )
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        evaluationAddEmployee(data.employee_id);
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const debounceForm = debounce(updateEmployee, 1000);

watch(
  () => props.data?.employee_id,
  () => {
    fetchData();
  },
);

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.data?.employee_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(t)("analysis.texts.empty_employee")) + " ", 1),
            _createElementVNode("button", {
              class: "btn btn-md btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
            }, _toDisplayString(_unref(t)("common.labels.add").toUpperCase()), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(baseTooltip), { position: "relative" }, {
                trigger: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-none btn-sm remove",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (del()))
                  }, [
                    _createVNode(_unref(svgIcon), {
                      icon: "trash",
                      size: "1.75rem"
                    })
                  ])
                ]),
                tooltip: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.delete")), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(employeeForm), {
              data: employeeData.value,
              "is-patch": true,
              onUpdateData: _unref(debounceForm)
            }, null, 8, ["data", "onUpdateData"])
          ], 64))
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.employee'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (addCancel())),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchEmployee), {
          "account-id": __props.data?.account_id,
          "company-id": __props.company?.company_id,
          ids: __props.data?.employee_id ? [__props.data.employee_id] : [],
          add: true,
          unic: true,
          "is-patch": false,
          onUpdateData: addSelect,
          "onNew:register": newRegister
        }, null, 8, ["account-id", "company-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseModal), {
      show: showModalNew.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.employee'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[5] || (_cache[5] = ($event: any) => (newRegisterCancel())),
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (newRegisterConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(employeeForm), {
          data: employeeData.value,
          "is-patch": false,
          onUpdateData: _cache[4] || (_cache[4] = ($event: any) => (employeeData.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.employee'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: employeeData.value?.name,
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})